import Resizer from "react-image-file-resizer";

export const resizeFile = (file) => {
    const { name ,size } = file;
    console.log("name size type",name,size)
    return new Promise((resolve) => {
        Resizer.imageFileResizer(
            file,
            400,
            300,
            'JPEG',
            80,
            0,
            (uri) => {
                resolve({
                    base64: uri,
                    name: name,
                    size: size,
                })
            },
            "base64"
            );
    });
}

